import { memo } from 'react';
import ErrorIcon from '@assets/images/ErrorIcon';
import { useIsNegativeHold } from '@utility/helperFunction';

const HoldExpiredMessage = ({ sendDate, message, className, iconClassName, messageClassName, }) => {
  const isExpired = useIsNegativeHold(sendDate);

  if (!isExpired || !message) return null;

  return (
    <div className={className || 'd-flex pt-1 px-1'}>
      <span className={iconClassName || "pr-1 pb-3"}>
        <ErrorIcon />
      </span>
      <span className={messageClassName || "text-break fw-500 fs_12"} style={{color:'black'}}>{message}</span>
    </div>
  );
};

export default memo(HoldExpiredMessage);
